import { FormControl } from '@angular/forms';


export const MockedList: any[] = [
  {
    name: 'Рома'
  },
  {
    name: 'Ілля'
  },
];


export interface FunnelForm {
  name: FormControl,
  currency: FormControl,
}
